import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

import MaterialListItemStyled from './MaterialListItemStyled';

const MediaItemWrapper = styled.div`
  position: relative;
  width: 148px;
  height: 92px;
  border: 2px solid ${COLORS.background};
  border-radius: 2px;
  transition: border-color 0.15s ease-out;

  .active & {
    border-color: ${COLORS.primary};
  }

  ${/* sc-selector */ MaterialListItemStyled}:hover & {
    border-color: ${COLORS.primary};
  }
`;

export default MediaItemWrapper;
